<app-loading *ngIf="contentReady"></app-loading>

<section class="bb-page"> <div class="bb-page-shell">
<!-- Header -->
<div class="bb-page-header">
  <div class="bb-page-title-block">
    <span class="bb-eyebrow">{{ "New employee" | transloco }}</span>
    <h2 class="bb-page-title">{{ "New employee" | transloco }}</h2>
  </div>
</div>

<div class="bb-card bb-p-20">
  <form class="bb-w-100" [formGroup]="data" (ngSubmit)="onSubmit()">
    <div class="bb-form-grid">

      @if(submitted && data.invalid) {
      <div class="bb-form-alert bb-field-full" role="alert">
        {{ 'Review the employee data before saving' | transloco }}
        @if(getMissingRequiredCount() > 0) {
        <span>
          ({{ getMissingRequiredCount() }} {{ 'required fields' | transloco }})
        </span>
        }
      </div>
      }

      @if(isAdmin){
      <div class="bb-field bb-field-full">
        <label class="bb-label" for="warehouse">{{ 'select' | transloco }} {{ 'Stock' | transloco }}</label>
        <div class="bb-select-wrap">
          <select id="warehouse" class="bb-select" [(ngModel)]="warehouseId" formControlName="warehouse" [ngClass]="{
            'is-invalid': data.get('warehouse')?.touched && data.get('warehouse')?.invalid,
            'is-valid': data.get('warehouse')?.touched && data.get('warehouse')?.valid
          }">
            <option value="" disabled selected>{{ 'select' | transloco }}</option>
            @for (warehouse of warehouses; track warehouse) {
            <option [value]="warehouse.id">{{ warehouse.name }}</option>
            }
          </select>
        </div>
        @if(shouldShowError('warehouse')) {
        <div class="bb-field-error">{{ getErrorMessage('warehouse', ('Stock' | transloco)) }}</div>
        }
      </div>
      }

      <div class="bb-field">
        <label class="bb-label" for="name">{{ 'Name' | transloco }}</label>
        <input class="bb-input" type="text" id="name" formControlName="name" placeholder="{{ 'Name' | transloco }}"
          [(ngModel)]="name" [ngClass]="{
            'is-invalid': data.get('name')?.touched && data.get('name')?.invalid,
            'is-valid': data.get('name')?.touched && data.get('name')?.valid
          }" />
        @if(shouldShowError('name')) {
        <div class="bb-field-error">{{ getErrorMessage('name', ('Name' | transloco)) }}</div>
        }
      </div>

      <div class="bb-field">
        <label class="bb-label" for="job_title">{{ 'job title' | transloco }}</label>
        <input class="bb-input" type="text" id="job_title" formControlName="job_title"
          placeholder="{{ 'job title' | transloco }}" [(ngModel)]="job_title" [ngClass]="{
            'is-invalid': data.controls['job_title'].touched && data.controls['job_title'].errors,
            'is-valid': data.controls['job_title'].touched && !data.controls['job_title'].errors,
            'is-touched': data.controls['job_title'].untouched && !data.controls['job_title'].errors,
          }" />
        @if(shouldShowError('job_title')) {
        <div class="bb-field-error">{{ getErrorMessage('job_title', ('job title' | transloco)) }}</div>
        }
      </div>

      <div class="bb-field">
        <label class="bb-label" for="salary">{{ 'salary' | transloco }}</label>
        <input class="bb-input" type="text" id="salary" formControlName="salary"
          placeholder="{{ 'salary' | transloco }}" [(ngModel)]="salary" [ngClass]="{
            'is-invalid': data.controls['salary'].touched && data.controls['salary'].errors,
            'is-valid': data.controls['salary'].touched && !data.controls['salary'].errors,
            'is-touched': data.controls['salary'].untouched && !data.controls['salary'].errors,
          }" />
        @if(shouldShowError('salary')) {
        <div class="bb-field-error">{{ getErrorMessage('salary', ('salary' | transloco)) }}</div>
        }
      </div>

      <div class="bb-field">
        <label class="bb-label" for="national_id">{{ 'grov_id' | transloco }}</label>
        <input class="bb-input" type="text" id="national_id" formControlName="national_id"
          placeholder="{{ 'grov_id' | transloco }}" [(ngModel)]="national_id" [ngClass]="{
            'is-invalid': data.get('national_id')?.touched && data.get('national_id')?.invalid,
            'is-valid': data.get('national_id')?.touched && data.get('national_id')?.valid
          }" />
      </div>

      <div class="bb-field">
        <label class="bb-label" for="phone">{{ 'phone' | transloco }}</label>
        <input class="bb-input" type="text" id="phone" formControlName="phone" placeholder="{{ 'phone' | transloco }}"
          [(ngModel)]="phone" [ngClass]="{
            'is-invalid': data.get('phone')?.touched && data.get('phone')?.invalid,
            'is-valid': data.get('phone')?.touched && data.get('phone')?.valid
          }" />
        @if(shouldShowError('phone')) {
        <div class="bb-field-error">{{ getErrorMessage('phone', ('phone' | transloco)) }}</div>
        }
      </div>

      <div class="bb-field">
        <label class="bb-label" for="address">{{ 'address' | transloco }}</label>
        <input class="bb-input" type="text" id="address" formControlName="address"
          placeholder="{{ 'address' | transloco }}" [(ngModel)]="address" [ngClass]="{
            'is-invalid': data.get('address')?.touched && data.get('address')?.invalid,
            'is-valid': data.get('address')?.touched && data.get('address')?.valid
          }" />
      </div>

      <div class="bb-field bb-field-full">
        <label class="bb-label">{{ 'user type' | transloco }}</label>
        <div class="bb-grid bb-gap-12">

          <label class="bb-card bb-p-12 bb-inline-flex bb-items-center bb-gap-12" *ngIf="isSuperAdmin" for="SuperAdmin">
            <input class="form-check-input bb-checkbox" type="radio" formControlName="type" id="SuperAdmin" value="10" />
            <span class="bb-font-semibold">{{ 'super admin' | transloco }}</span>
          </label>

          <label class="bb-card bb-p-12 bb-inline-flex bb-items-center bb-gap-12" *ngIf="isAdmin || isSuperAdmin" for="admin">
            <input class="form-check-input bb-checkbox" type="radio" formControlName="type" id="admin" value="1" />
            <span class="bb-font-semibold">{{ 'admin' | transloco }}</span>
          </label>

          <label class="bb-card bb-p-12 bb-inline-flex bb-items-center bb-gap-12" for="subadmin">
            <input class="form-check-input bb-checkbox" type="radio" formControlName="type" id="subadmin" value="6" />
            <span class="bb-font-semibold">{{ 'subadmin' | transloco }}</span>
          </label>

          <label class="bb-card bb-p-12 bb-inline-flex bb-items-center bb-gap-12" for="employee">
            <input class="form-check-input bb-checkbox" type="radio" formControlName="type" id="employee" value="7" />
            <span class="bb-font-semibold">{{ 'employee' | transloco }}</span>
          </label>

          @if(warehouseTypeService.isCompany()){

          <label class="bb-card bb-p-12 bb-inline-flex bb-items-center bb-gap-12" for="Affiliation">
            <input class="form-check-input bb-checkbox" type="radio" formControlName="type" id="Affiliation" value="2" />
            <span class="bb-font-semibold">{{ 'Affiliation' | transloco }}</span>
          </label>

          <label class="bb-card bb-p-12 bb-inline-flex bb-items-center bb-gap-12" for="A">
            <input class="form-check-input bb-checkbox" type="radio" formControlName="type" id="A" value="3" />
            <span class="bb-font-semibold">{{ 'Page A' | transloco }}</span>
          </label>

          <label class="bb-card bb-p-12 bb-inline-flex bb-items-center bb-gap-12" for="B">
            <input class="form-check-input bb-checkbox" type="radio" formControlName="type" id="B" value="4" />
            <span class="bb-font-semibold">{{ 'B' | transloco }}</span>
          </label>

          <label class="bb-card bb-p-12 bb-inline-flex bb-items-center bb-gap-12" for="C">
            <input class="form-check-input bb-checkbox" type="radio" formControlName="type" id="C" value="5" />
            <span class="bb-font-semibold">{{ 'C' | transloco }}</span>
          </label>

          <label class="bb-card bb-p-12 bb-inline-flex bb-items-center bb-gap-12" for="client">
            <input class="form-check-input bb-checkbox" type="radio" formControlName="type" id="client" value="9" />
            <span class="bb-font-semibold">{{ 'client' | transloco }}</span>
          </label>
          }

          @if(warehouseTypeService.isCompany() || warehouseTypeService.isShipping()){
          <label class="bb-card bb-p-12 bb-inline-flex bb-items-center bb-gap-12" for="deliveryhero">
            <input class="form-check-input bb-checkbox" type="radio" formControlName="type" id="deliveryhero" value="8" />
            <span class="bb-font-semibold">{{ 'deliveryhero' | transloco }}</span>
          </label>
          }
        </div>
      </div>

      <div class="bb-field bb-field-full">
        <label class="bb-label">{{ 'access pages' | transloco }}</label>
        <div class="bb-grid bb-gap-12">
          <label class="bb-card bb-p-12 bb-inline-flex bb-items-center bb-gap-12" *ngFor="let page of accessPagesList">
            <input class="form-check-input bb-checkbox" type="checkbox" [value]="page.value" (change)="onCheckboxChange($event)"
              [checked]="page.value === 7 || accessPages.includes(page.value)" [disabled]="page.value === 7" />
            <span class="bb-font-semibold">{{ page.label | transloco }}</span>
          </label>
        </div>
      </div>

      <div class="bb-field bb-field-full">
        <button type="submit" class="bb-btn bb-btn-primary bb-w-100" [class.is-disabled]="data.invalid">
          {{ "Submit" | transloco }}
        </button>
      </div>

    </div>
  </form>
</div>
</div> </section>